// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"504f05c2","988":"1c2294c2"}[chunkId] + ".chunk.css";
};